import ReactTooltip from 'react-tooltip';
import React, { useEffect, useState, useMemo, useRef } from "react"
import Flatpickr from "react-flatpickr";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import Spinner from 'react-bootstrap/Spinner';
import styles from "./index.module.css";
import stylesBase from "./base.module.css";
import LoadingModal from './Unit/LoadingModal';

const CLIENT_ID = "795120460818-gie3v2di14h5ed8vpinqndkao7iv7frk.apps.googleusercontent.com";
const REDIRECT_URI = "https://azumayavietnam.com/en/test"

//get all data
//https://graph.facebook.com/v21.0/act_2639912896390751/insights?level=ad&time_increment=1&fields=account_id,account_name,campaign_id,campaign_name,objective, adset_id,adset_name,optimization_goal, ad_id,ad_name, impressions,reach,frequency, clicks,unique_clicks,inline_link_clicks,outbound_clicks, spend,cpm,cpc,ctr, actions,action_values,conversions,conversion_values, cost_per_action_type,purchase_roas, video_p25_watched_actions,video_p50_watched_actions, video_p75_watched_actions,video_p100_watched_actions, engagement_rate_ranking,conversion_rate_ranking,quality_ranking&time_range={'since':'2025-12-01','until':'2025-12-31'} &access_token=EAAG8CqX9qtYBQTW7G9jiiUxRRr0GZA3BCvonIKFaUWHEeBZBl3643hi2JYXpu60HIlfTkZBEB2MSgUK9TFnu0qgbsm0OZBexcFNCOJI98pgRZAmoZBGmMvKMZBNDr9dlnBlmsYZCmJzOvMqUZB1DZCwEWI5qAWSBxMZCP8jPo8ZCEdqsnulzZAf0W1lV5zfFkLz31qQZDZD
//get image url ads
//https://graph.facebook.com/v21.0/act_2639912896390751/ads?fields=id,name, creative{ id, image_url, thumbnail_url, object_story_spec } &access_token=EAAG8CqX9qtYBQTW7G9jiiUxRRr0GZA3BCvonIKFaUWHEeBZBl3643hi2JYXpu60HIlfTkZBEB2MSgUK9TFnu0qgbsm0OZBexcFNCOJI98pgRZAmoZBGmMvKMZBNDr9dlnBlmsYZCmJzOvMqUZB1DZCwEWI5qAWSBxMZCP8jPo8ZCEdqsnulzZAf0W1lV5zfFkLz31qQZDZD


export default function GoogleAds({ itemsPerPage = 20}) {
     const {t} = useTranslation()
     const [propertyID, setPropertyID] = useState("366123786")
     const [isLoading, setIsLoading] = useState(false)
     const [filteredAdsData, setFilteredAdsData] = useState([]);
     console.log("🚀 ~ GoogleAds ~ filteredAdsData:", filteredAdsData)
     const [filteredKeywordData, setFilteredKeywordData] = useState([]);
     console.log("🚀 ~ GoogleAds ~ filteredKeywordData:", filteredKeywordData)
     const [adsDataByCity, setAdsDataByCity] = useState(null)
     const [startDate, setStartDate] = useState(() => dayjs().startOf("month").format("YYYY-MM-DD") );
     const [endDate, setEndDate] = useState(() => dayjs().format("YYYY-MM-DD") );
     const [accessToken, setAccessToken] = useState(null);
     const [adsData, setAdsData] = useState([]);
     const [keywordData, setKeywordData] = useState([]);
     const [sortType, setSortType] = useState("");
     const [sortRankType, setSortRankType] = useState("");
     const [resource, setResource] = useState("20838761231");
     const [resourceKeyword, setResourceKeyword] = useState("20670314637");

const fetchAdsData = async () => {
  setIsLoading(true);

  try {
    const res = await fetch( `/api/googleAds/ads-data/campaign/${startDate}/${endDate}` );
 
      if (!res.ok) {
        throw new Error('Network response was not ok');
      }
      const responseData = await res.json();
      if(responseData){
        setIsLoading(false) 
        setAdsData(responseData)
      }

    } catch (error) {
      console.error('Error:', error);
  }
  }

  const fetchAdsKeywordData = async () => {
  setIsLoading(true);

  try {
    const res = await fetch( `/api/googleAds/ads-data/keyword/${startDate}/${endDate}` );
 
      if (!res.ok) {
        throw new Error('Network response was not ok');
      }
      const responseData = await res.json();
      if(responseData){
        setIsLoading(false) 
        setKeywordData(responseData)
      }

    } catch (error) {
      console.error('Error:', error);
  }
  }

const fetchAdsDataByCity = async () => {
  setIsLoading(true);

  try {
    const res = await fetch( `/api/googleAds/ads-conversions-by-city/${startDate}/${endDate}` );
 
      if (!res.ok) {
        throw new Error('Network response was not ok');
      }
      const responseData = await res.json();
      if(responseData){
        setIsLoading(false) 
        setAdsDataByCity(responseData)
      }

    } catch (error) {
      console.error('Error:', error);
  }
  }

// useEffect(() => {
//   const logged = localStorage.getItem("google_logged_in");
//   if (logged === "true") {
//     setIsLoggedIn(true);
//   }
  
// }, []);

useEffect(() => {
  if (!startDate || !endDate) return;

  fetchAdsData();
  fetchAdsDataByCity()
  fetchAdsKeywordData()
}, [startDate, endDate, propertyID]);

function groupCampaignsById(data = []) {
  return data.reduce((acc, item) => {
    const id = item?.campaign?.id;
    if (!id) return acc;

    if (!acc[id]) acc[id] = [];
    acc[id].push(item);

    return acc;
  }, {});
}

useEffect(() => {
    if (!adsData?.length) return;
    const filtered = groupCampaignsById(adsData)
    setFilteredAdsData(filtered)
}, [adsData])

useEffect(() => {
    if (!keywordData?.length) return;
    const filtered = groupCampaignsById(keywordData)
    setFilteredKeywordData(filtered)
}, [keywordData])

const campaignData = filteredAdsData?.[resource] ?? [];

const keywordCampaignData = filteredKeywordData?.[resourceKeyword] ?? [];

const sortedData = useMemo(() => {
   if (!Array.isArray(campaignData)) return [];

  let temp = [...campaignData];

    switch (sortType) {
      case "clicks-asc":
        temp.sort(
          (a, b) => Number(a.metrics.clicks) - Number(b.metrics.clicks)
        );
        break;

      case "clicks-desc":
        temp.sort(
          (a, b) => Number(b.metrics.clicks) - Number(a.metrics.clicks)
        );
        break;

      case "impressions-asc":
        temp.sort(
          (a, b) => Number(a.metrics.impressions) - Number(b.metrics.impressions)
        );
        break;

      case "impressions-desc":
        temp.sort(
          (a, b) => Number(b.metrics.impressions) - Number(a.metrics.impressions)
        );
        break;

      case "cost-asc":
        temp.sort(
          (a, b) =>
            Number(a.metrics.costMicros) - Number(b.metrics.costMicros)
        );
        break;

      case "cost-desc":
        temp.sort(
          (a, b) =>
            Number(b.metrics.costMicros) - Number(a.metrics.costMicros)
        );
        break;
          case "conversions-asc":
        temp.sort(
          (a, b) =>
            Number(a.metrics.conversions) - Number(b.metrics.conversions)
        );
        break;

      case "conversions-desc":
        temp.sort(
          (a, b) =>
            Number(b.metrics.conversions) - Number(a.metrics.conversions)
        );
        break;
         case "cpc-asc":
        temp.sort((a, b) => {
            const cpcA =
              Number(a.metrics.clicks) > 0
                ? Number(a.metrics.costMicros) / 1_000_000 / Number(a.metrics.clicks)
                : 0;

            const cpcB =
              Number(b.metrics.clicks) > 0
                ? Number(b.metrics.costMicros) / 1_000_000 / Number(b.metrics.clicks)
                : 0;

            return cpcA - cpcB;
          });
          break;
      case "cpc-desc":
        temp.sort((a, b) => {
            const cpcA =
              Number(a.metrics.clicks) > 0
                ? Number(a.metrics.costMicros) / 1_000_000 / Number(a.metrics.clicks)
                : 0;

            const cpcB =
              Number(b.metrics.clicks) > 0
                ? Number(b.metrics.costMicros) / 1_000_000 / Number(b.metrics.clicks)
                : 0;

            return cpcB - cpcA;
          });
          break;

      case "name-asc":
        temp.sort((a, b) =>
          a.campaign.name.localeCompare(b.campaign.name)
        );
        break;

      case "name-desc":
        temp.sort((a, b) =>
          b.campaign.name.localeCompare(a.campaign.name)
        );
        break;
        default:
        break;
    }

    return temp;
}, [sortType, campaignData]);

const sortedKeywordData = useMemo(() => {
   if (!Array.isArray(keywordCampaignData)) return [];

  let temp = [...keywordCampaignData];

    switch (sortType) {
      case "clicks-asc":
        temp.sort(
          (a, b) => Number(a.metrics.clicks) - Number(b.metrics.clicks)
        );
        break;

      case "clicks-desc":
        temp.sort(
          (a, b) => Number(b.metrics.clicks) - Number(a.metrics.clicks)
        );
        break;

      case "impressions-asc":
        temp.sort(
          (a, b) => Number(a.metrics.impressions) - Number(b.metrics.impressions)
        );
        break;

      case "impressions-desc":
        temp.sort(
          (a, b) => Number(b.metrics.impressions) - Number(a.metrics.impressions)
        );
        break;

      case "cost-asc":
        temp.sort(
          (a, b) =>
            Number(a.metrics.costMicros) - Number(b.metrics.costMicros)
        );
        break;

      case "cost-desc":
        temp.sort(
          (a, b) =>
            Number(b.metrics.costMicros) - Number(a.metrics.costMicros)
        );
        break;

      case "conversions-asc":
        temp.sort(
          (a, b) =>
            Number(a.metrics.conversions) - Number(b.metrics.conversions)
        );
        break;

      case "conversions-desc":
        temp.sort(
          (a, b) =>
            Number(b.metrics.conversions) - Number(a.metrics.conversions)
        );
        break;

      case "cpc-asc":
        temp.sort((a, b) => {
            const cpcA =
              Number(a.metrics.clicks) > 0
                ? Number(a.metrics.costMicros) / 1_000_000 / Number(a.metrics.clicks)
                : 0;

            const cpcB =
              Number(b.metrics.clicks) > 0
                ? Number(b.metrics.costMicros) / 1_000_000 / Number(b.metrics.clicks)
                : 0;

            return cpcA - cpcB;
          });
          break;

      case "cpc-desc":
        temp.sort((a, b) => {
            const cpcA =
              Number(a.metrics.clicks) > 0
                ? Number(a.metrics.costMicros) / 1_000_000 / Number(a.metrics.clicks)
                : 0;

            const cpcB =
              Number(b.metrics.clicks) > 0
                ? Number(b.metrics.costMicros) / 1_000_000 / Number(b.metrics.clicks)
                : 0;

            return cpcB - cpcA;
          });
          break;

      case "name-asc":
        temp.sort((a, b) =>
          a.campaign.name.localeCompare(b.campaign.name)
        );
        break;

      case "name-desc":
        temp.sort((a, b) =>
          b.campaign.name.localeCompare(a.campaign.name)
        );
        break;
        
      case "!az":
        temp = temp.filter(item => {
          const keyword = item.adGroupCriterion?.keyword?.text?.toLowerCase() || "";
          return !["azumaya", "東屋"].some(text =>
            keyword.includes(text.toLowerCase())
          );
        });
        break;
        case "az":
        break;
        default:
        break;
    }

    return temp;
}, [sortType, keywordCampaignData]);

    const [currentPage, setCurrentPage] = useState(1);
    const totalPages = Math.ceil(sortedData?.length / itemsPerPage);
    const currentAdsData = useMemo(() => {
    if (!Array.isArray(sortedData)) return [];

    const start = (currentPage - 1) * itemsPerPage;
    const end = currentPage * itemsPerPage;

    return sortedData.slice(start, end);
}, [sortedData, currentPage, itemsPerPage]);
  const goPrev = () => setCurrentPage(p => Math.max(p - 1, 1));
  const goNext = () => setCurrentPage(p => Math.min(p + 1, totalPages));

      const [currentPage2, setCurrentPage2] = useState(1);
    const totalPages2 = Math.ceil(sortedKeywordData?.length / itemsPerPage);
    const currentAdsData2 = useMemo(() => {
    if (!Array.isArray(sortedKeywordData)) return [];

    const start = (currentPage2 - 1) * itemsPerPage;
    const end = currentPage2 * itemsPerPage;

    return sortedKeywordData.slice(start, end);
}, [sortedKeywordData, currentPage2, itemsPerPage]);

  const goPrev2 = () => setCurrentPage2(p => Math.max(p - 1, 1));
  const goNext2 = () => setCurrentPage2(p => Math.min(p + 1, totalPages2));

const campaignStats = adsData.reduce((acc, row) => {
  const campaignId = row.campaign.id;
  const campaignName = row.campaign.name;
  const campaignStatus = row.campaign.status;
  const campaignBudget = Number(row.campaignBudget.amountMicros)/1000000

  if (!acc[campaignId]) {
    acc[campaignId] = {
      campaignId,
      campaignName,
      campaignStatus,
      campaignBudget,
      impressions: 0,
      clicks: 0,
      conversions: 0,
      costMicros: 0,
    };
  }

  acc[campaignId].impressions += Number(row.metrics.impressions || 0);
  acc[campaignId].clicks += Number(row.metrics.clicks || 0);
  acc[campaignId].conversions += Number(row.metrics.conversions || 0);
  acc[campaignId].costMicros += Number(row.metrics.costMicros || 0);

  return acc;
}, {});
const tableData = Object.values(campaignStats).map(item => {
  const cost = item.costMicros / 1_000_000;
  const ctr = item.impressions
    ? (item.clicks / item.impressions) * 100
    : 0;
  const cpa = item.conversions
    ? cost / item.conversions
    : 0;

  return {
    campaign: item.campaignName,
    budget: item.campaignBudget,
    status: item.campaignStatus,
    impressions: item.impressions,
    clicks: item.clicks,
    ctr: ctr.toFixed(2) + "%",
    conversions: item.conversions,
    cost: cost.toFixed(2),
    cpa: cpa.toFixed(2),
  };
});
 const sortedRankData = useMemo(() => {
   if (!Array.isArray(tableData)) return [];

  let temp = [...tableData];

    switch (sortType) {
      case "clicks-asc":
        temp.sort(
          (a, b) => Number(a.clicks) - Number(b.clicks)
        );
        break;

      case "clicks-desc":
        temp.sort(
          (a, b) => Number(b.clicks) - Number(a.clicks)
        );
        break;

      case "impressions-asc":
        temp.sort(
          (a, b) => Number(a.impressions) - Number(b.impressions)
        );
        break;

      case "impressions-desc":
        temp.sort(
          (a, b) => Number(b.impressions) - Number(a.impressions)
        );
        break;

      case "cost-asc":
        temp.sort(
          (a, b) =>
            Number(a.cost) - Number(b.cost)
        );
        break;

      case "cost-desc":
        temp.sort(
          (a, b) =>
            Number(b.cost) - Number(a.cost)
        );
        break;
          case "conversions-asc":
        temp.sort(
          (a, b) =>
            Number(a.conversions) - Number(b.conversions)
        );
        break;

      case "conversions-desc":
        temp.sort(
          (a, b) =>
            Number(b.conversions) - Number(a.conversions)
        );
        break;
        case "cpa-asc":
        temp.sort(
          (a, b) =>
            Number(a.cpa) - Number(b.cpa)
        );
        break;

      case "cpa-desc":
        temp.sort(
          (a, b) =>
            Number(b.cpa) - Number(a.cpa)
        );
        break;
          case "ctr-asc":
        temp.sort(
          (a, b) =>
            Number(a.ctr) - Number(b.ctr)
        );
        break;

      case "ctr-desc":
        temp.sort(
          (a, b) =>
            Number(b.ctr) - Number(a.ctr)
        );
        break;
        default:
        break;
    }
    return temp;
  }, [sortRankType, tableData]);      
const getCityName = (name) => {
  switch(name) {
    case "Ho Chi Minh": return "HCM"
    case "Hanoi" : return "HN"
    case "Hai Phong" : return "HP"
    case "Da Nang" : return "DN"
    case "Phnom Penh" : return "PP"
    default: 
    break;
  }
}              
    return (
<div>
  <ReactTooltip id = 'marketing' style={{
                   fontSize: 20,
                   maxWidth: 400,
                   whiteSpace: "pre-line",
                   backgroundColor: "#000",
                   borderRadius: 10,
                   zIndex: 99999
                 }}/>
     <div style={{ padding: 20, backgroundColor:"#fff" }}>
        <div className="d-flex mt-5 ml-3">
             <div style={{marginRight: 10, width: 'fit-content'}}>
                   <Flatpickr 
                     value={startDate}
                       options={{
                       dateFormat:'Y-m-d'}} 
                        className={`col-md-12 ${styles.contentBookingDate} ${styles.webkitAppearance}`}  
                         placeholder={t('booking.date_in')} 
                         onChange={(dates)=>{
                         setStartDate(dayjs(dates[0]).format("YYYY-MM-DD"));
                      }} />
             </div>
               <div style={{marginRight: 10, width: 'fit-content'}}>
                    <Flatpickr 
                            value={endDate}
                            options={{
                              minDate: dayjs(startDate).format("YYYY-MM-DD"),
                              dateFormat:'Y-m-d'}} 
                            className={`col-md-12 ${styles.contentBookingDate} ${styles.webkitAppearance}`}  
                            placeholder={t('booking.date_out')} 
                            onChange={(dates) =>{
                              setEndDate(dayjs(dates[0]).format("YYYY-MM-DD"));
                            }} />
                            </div>
                             <div style={{marginRight: 10, width: 'fit-content'}}>
                                            <button 
                                            className={`col-md-12 ${styles.contentBookingDate} webkit-appearance`} 
                                            onClick={() => {
                                               const lastMonthStart = dayjs(startDate).subtract(1, "month").startOf("month").format("YYYY-MM-DD");
                                               const lastMonthEnd = dayjs(endDate).subtract(1, "month").endOf("month").format("YYYY-MM-DD");
                                              setStartDate(lastMonthStart);
                                              setEndDate(lastMonthEnd);
                                            }}>
                                              Last Month
                                            </button>
                                           </div>
                              {/* <div style={{marginRight: 10, width: 'fit-content'}}> */}
            {/* <button className={`${stylesBase.baseBtn}`}  onClick={() => fetchAdsData(accessToken)}>Refresh</button> */}
            {/* </div>          */}
        </div>
           </div>
      {isLoading && (
           <LoadingModal />
          )}

          <div>
            <div className="d-flex align-items-center">
            <img src="https://cdn-icons-png.flaticon.com/512/2875/2875421.png" alt="Google Ads" style={{width: 60, height: 60, marginLeft: 30}}/>
          <div style={{fontSize: 60, fontWeight: 'bold', textAlign: 'left', marginLeft: 10}}>Google Ads Report</div>
          </div>
               <div style={{fontSize: 50, fontWeight: 'bold', textAlign: 'left', marginLeft: 30, marginTop: 10}}>Overall</div>
               <div className="container-fluid">
                <div className="row">
                <div className="col-md-12">
                    <div className="mt-4">
                  <table border="1" style={{...tableStyle}}>
                    <thead>
                      <tr>
                        <th style={{...thStyle, ...stickyHeader}}>No.</th>
                        <th style={{...thStyle, ...stickyHeader}} data-tip={t('marketing.googleAds.campaignName')} data-for="marketing">Campaign Name</th>
                        <th style={{...thStyle, ...stickyHeader, background: "linear-gradient(135deg, #4285F4 0%, #6EA8FF 100%)"}}>
                             <div className="d-flex justify-content-between align-items-center" data-tip={t('marketing.googleAds.conversion')} data-for="marketing">
                            <span>Conversions</span>
                            <div className="d-flex flex-column">
                              <button
                                className="btn-sort"
                                onClick={() => setSortType("conversions-asc")}
                                 style={{backgroundColor: 'transparent', border: 'none', height: 10}}
                              >
                                <i className="fa-solid fa-caret-up" style={{color: 'white', fontSize: 20}}></i>
                              </button>
                              <button
                                className="btn-sort"
                                onClick={() => setSortType("conversions-desc")}
                                style={{backgroundColor: 'transparent', border: 'none', height: 10, marginBottom: 10}}

                              >
                                <i className="fa-solid fa-caret-down" style={{color: 'white', fontSize: 20}}></i>
                              </button>
                            </div>
                          </div>
                        </th>
                        <th style={{...thStyle, ...stickyHeader, background: "linear-gradient(135deg, #DB4437 0%, #FF6B5E 100%)"}} data-tip={t('marketing.googleAds.cvr')} data-for="marketing">Budget</th>
                        <th style={{...thStyle, ...stickyHeader, background: "linear-gradient(135deg, #F4B400 0%, #FFD95A 100%)"}} data-tip={t('marketing.googleAds.cvr')} data-for="marketing">CVR</th>
                        <th style={{...thStyle, ...stickyHeader, background: "linear-gradient(135deg, #0F9D58 0%, #34C97B 100%)"}} data-tip={t('marketing.googleAds.impression')} data-for="marketing">Impression</th>
                        <th style={{...thStyle, ...stickyHeader, background: "linear-gradient(135deg, #AB47BC 0%, #D47BE3 100%)"}} data-tip={t('marketing.googleAds.click')} data-for="marketing">Click</th>
                        <th style={{...thStyle, ...stickyHeader, background: "linear-gradient(135deg, #00ACC1 0%, #4DD9E8 100%)"}} data-tip={t('marketing.googleAds.cost')} data-for="marketing">Cost</th>
                        <th style={{...thStyle, ...stickyHeader, background: "linear-gradient(135deg, #FB8C00 0%, #FFB347 100%)"}} data-tip={t('marketing.googleAds.cpa')} data-for="marketing">CPA</th>
                        <th style={{...thStyle, ...stickyHeader, background: "linear-gradient(135deg, #ff00ae 0%, #ff66d1 100%)"}} data-tip={t('marketing.googleAds.ctr')} data-for="marketing">CTR</th>
                    </tr>
                    </thead>
                    <tbody>
                      {sortedRankData
                      .map((row, idx) => {
                        
                        return (
                        <tr key={idx}  style={{backgroundColor: idx % 2 === 0 ? "#fff" : "#E6E6E6"}}
                        >
                          <td style={tdStyle}>{idx+1}</td>
                          <td style={{...tdStyle, textAlign: 'left'}}>
                            <div className="d-flex justify-content-between">
                                <div style={{color:row.status == "ENABLED" ? "#000" : "#ccc"}}>{row.campaign}</div>
                                <div style={{borderRadius: 10, border: `3px solid ${row.status == "ENABLED" ? "#23C552" : "#F84F31"}`, paddingLeft: 5, paddingRight: 5, color: row.status == "ENABLED" ? "#23C552" : "#F84F31", fontWeight: 'bold'}}>{row.status == "ENABLED" ? "ACTIVE" : "CLOSED"}</div>
                            </div>
                          </td>
                          {adsDataByCity && (
                          <td style={tdStyle}>{Intl.NumberFormat("de-DE", { minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(row.conversions)}
                            {adsDataByCity[row.campaign] && (
                              Object.entries(adsDataByCity[row.campaign]).map(([city, value], idx) => (
                                  <div key={idx}>
                                    {getCityName(city)} ({Math.round(value)})
                                  </div>
                                ))
                              )}
                                                          
                          </td>
                          )}
                          <td style={tdStyle}>{Intl.NumberFormat("de-DE").format(row.budget)}đ</td>
                          <td style={tdStyle}>{Intl.NumberFormat("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(row.clicks > 0 ? (row.conversions / row.clicks)*100 : 0)}%</td>
                          <td style={tdStyle}>{Intl.NumberFormat("de-De").format(row.impressions)}</td>
                          <td style={tdStyle}>{Intl.NumberFormat("de-De").format(row.clicks)}</td>
                          <td style={tdStyle}>{Intl.NumberFormat("de-De").format(row.cost)}đ</td>
                          <td style={tdStyle}>{Intl.NumberFormat("de-De").format(row.cpa)}đ</td>
                          <td style={tdStyle}>{row.ctr}</td>
                        </tr>
                        )
                    })}
                    </tbody>
                  </table>
                  </div>
                    
                  </div>
                </div>
               </div>
            <div style={{fontSize: 50, fontWeight: 'bold', textAlign: 'left', marginLeft: 30, marginTop: 10}}>Detail</div>
            <div className="container-fluid">
              <div className="row">
                  <div className="col-md-12">
                       <div style={{marginRight: 10, width: 'fit-content'}}>
           <select className={styles.contentBookingBranchSelect} value={resource} onChange={(e) => {
            setResource(e.target.value)
            }}>
            {Object.entries(filteredAdsData).map(([campaignId, rows]) => (
                <option key={campaignId} value={campaignId}>
                  {rows[0]?.campaign?.name} ({rows[0].campaign?.status === "ENABLED" ? "ACTIVE" : "CLOSED"})
                </option>
              ))}
      </select>
       <div style={paginationContainerStyle}>
          <button
            onClick={goPrev}
            disabled={currentPage === 1}
            style={{
              ...paginationBtnStyle,
              ...(currentPage === 1 && paginationBtnDisabledStyle),
            }}
          >
            «
          </button>

          <span style={paginationTextStyle}>
            Page {currentPage} / {totalPages}
          </span>

          <button
            onClick={goNext}
            disabled={currentPage === totalPages}
            style={{
              ...paginationBtnStyle,
              ...(currentPage === totalPages &&
                paginationBtnDisabledStyle),
            }}
          >
            »
          </button>
        </div>
        </div>
                    <div>
                  <table border="1" style={{ ...tableStyle, marginTop: 20 }}>
                    <thead>
                      <tr>
                        <th style={{...thStyle, ...stickyHeader2}}>No.</th>
                        <th style={{...thStyle, ...stickyHeader2}} data-tip={t('marketing.googleAds.campaignID')} data-for="marketing">Campaign ID</th>
                        <th style={{...thStyle, ...stickyHeader2}}  data-tip={t('marketing.googleAds.campaignName')} data-for="marketing">Campaign Name</th>
                        {/* <th style={{...thStyle, ...stickyHeader2}}>Status</th> */}
                        {/* <th style={{...thStyle, ...stickyHeader2}}>Channel Type</th> */}
                        
                        <th style={{...thStyle, ...stickyHeader2, background: "linear-gradient(135deg, #4285F4 0%, #6EA8FF 100%)"}} data-tip={t('marketing.googleAds.conversion')} data-for="marketing">
                          <div className="d-flex justify-content-between align-items-center">
                            <span>Conversions</span>
                            <div className="d-flex flex-column">
                              <button
                                className="btn-sort"
                                onClick={() => setSortType("conversions-asc")}
                                 style={{backgroundColor: 'transparent', border: 'none', height: 10}}
                              >
                                <i className="fa-solid fa-caret-up" style={{color: 'white', fontSize: 20}}></i>
                              </button>
                              <button
                                className="btn-sort"
                                onClick={() => setSortType("conversions-desc")}
                                style={{backgroundColor: 'transparent', border: 'none', height: 10, marginBottom: 10}}
                              >
                                <i className="fa-solid fa-caret-down" style={{color: 'white', fontSize: 20}}></i>
                              </button>
                            </div>
                          </div>
                        </th>
                         <th style={{...thStyle, ...stickyHeader2, background: "linear-gradient(135deg, #DB4437 0%, #FF6B5E 100%)"}}  data-tip={t('marketing.googleAds.impression')} data-for="marketing">
                          <div className="d-flex justify-content-between align-items-center">
                            <span>Impressions</span>
                            <div className="d-flex flex-column">
                              <button
                                className="btn-sort"
                                onClick={() => setSortType("impressions-asc")}
                                 style={{backgroundColor: 'transparent', border: 'none', height: 10}}
                              >
                                <i className="fa-solid fa-caret-up" style={{color: 'white', fontSize: 20}}></i>
                              </button>
                              <button
                                className="btn-sort"
                                onClick={() => setSortType("impressions-desc")}
                                style={{backgroundColor: 'transparent', border: 'none', height: 10, marginBottom: 10}}

                              >
                                <i className="fa-solid fa-caret-down" style={{color: 'white', fontSize: 20}}></i>
                              </button>
                            </div>
                          </div>
                        </th>
                       <th style={{...thStyle, ...stickyHeader2, background: "linear-gradient(135deg, #F4B400 0%, #FFD95A 100%)"}}>
                          <div className="d-flex justify-content-between align-items-center"   data-tip={t('marketing.googleAds.click')} data-for="marketing">
                            <span>Clicks</span>
                            <div className="d-flex flex-column ml-1">
                              <button
                                className="btn-sort"
                                onClick={() => setSortType("clicks-asc")}
                                 style={{backgroundColor: 'transparent', border: 'none', height: 10}}
                              >
                                <i className="fa-solid fa-caret-up" style={{color: 'white', fontSize: 20}}></i>
                              </button>
                              <button
                                className="btn-sort"
                                onClick={() => setSortType("clicks-desc")}
                                style={{backgroundColor: 'transparent', border: 'none', height: 10, marginBottom: 10}}
                              >
                                <i className="fa-solid fa-caret-down" style={{color: 'white', fontSize: 20}}></i>
                              </button>
                            </div>
                          </div>
                        </th>
                         
                        <th style={{...thStyle, ...stickyHeader2, background: "linear-gradient(135deg, #0F9D58 0%, #34C97B 100%)"}}>
                           <div className="d-flex justify-content-between align-items-center"   data-tip={t('marketing.googleAds.cost')} data-for="marketing">
                            <span>Cost</span>
                            <div className="d-flex flex-column">
                              <button
                                className="btn-sort"
                                onClick={() => setSortType("cost-asc")}
                                 style={{backgroundColor: 'transparent', border: 'none', height: 10}}
                              >
                                <i className="fa-solid fa-caret-up" style={{color: 'white', fontSize: 20}}></i>
                              </button>
                              <button
                                className="btn-sort"
                                onClick={() => setSortType("cost-desc")}
                                style={{backgroundColor: 'transparent', border: 'none', height: 10, marginBottom: 10}}

                              >
                                <i className="fa-solid fa-caret-down" style={{color: 'white', fontSize: 20}}></i>
                              </button>
                            </div>
                          </div>
                        </th>
                        
                        <th style={{...thStyle, ...stickyHeader2, background: "linear-gradient(135deg, #AB47BC 0%, #D47BE3 100%)"}}>
                           <div className="d-flex justify-content-between align-items-center"   data-tip={t('marketing.googleAds.cpc')} data-for="marketing">
                            <span>CPC</span>
                            <div className="d-flex flex-column">
                              <button
                                className="btn-sort"
                                onClick={() => setSortType("cpc-asc")}
                                 style={{backgroundColor: 'transparent', border: 'none', height: 10}}
                              >
                                <i className="fa-solid fa-caret-up" style={{color: 'white', fontSize: 20}}></i>
                              </button>
                              <button
                                className="btn-sort"
                                onClick={() => setSortType("cpc-desc")}
                                style={{backgroundColor: 'transparent', border: 'none', height: 10, marginBottom: 10}}
                              >
                                <i className="fa-solid fa-caret-down" style={{color: 'white', fontSize: 20}}></i>
                              </button>
                            </div>
                          </div>
                        </th>
                        <th style={{...thStyle, ...stickyHeader2, background: "linear-gradient(135deg, #00ACC1 0%, #4DD9E8 100%)"}}   data-tip={t('marketing.googleAds.cpa')} data-for="marketing">CPA</th>
                        <th style={{...thStyle, ...stickyHeader2, background: "linear-gradient(135deg, #FB8C00 0%, #FFB347 100%)"}}   data-tip={t('marketing.googleAds.ctr')} data-for="marketing">CTR</th>
                        <th style={{...thStyle, ...stickyHeader2, background: "linear-gradient(135deg, #ff00ae 0%, #ff66d1 100%)"}}   data-tip={t('marketing.googleAds.cpm')} data-for="marketing">CPM</th>
                  
                        <th style={{...thStyle, ...stickyHeader2}}>Date</th>
                        <th style={{...thStyle, ...stickyHeader2}} data-tip={t('marketing.ga4.device')} data-for="marketing">Device</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentAdsData
                      .filter(row => row.campaign.id === resource)
                      .map((row, idx) => {
                        return (
                        <tr key={idx} style={{backgroundColor: idx % 2 == 0 ? "#fff" : "#E6E6E6"}} 
                        >
                          <td style={tdStyle}>{idx+1}</td>
                          <td style={tdStyle}>{row.campaign?.id}</td>
                          <td style={tdStyle}>{row.campaign?.name}</td>
                          {/* <td style={{...tdStyle, backgroundColor: row.campaign?.status == "ENABLED" ? "#80EF91" : "red"}}>{row.campaign?.status}</td> */}
                          {/* <td style={tdStyle}>{row.campaign?.advertisingChannelType}</td> */}
                          <td style={tdStyle}>{row.metrics?.conversions}</td>
                          <td style={tdStyle}>{row.metrics?.clicks}</td>
                          <td style={tdStyle}>{row.metrics?.impressions}</td>
                          <td style={tdStyle}>{Intl.NumberFormat("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format((row.metrics?.costMicros)/1000000)}đ</td>
                          <td style={tdStyle}>{row.metrics?.clicks > 0 ? Intl.NumberFormat("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) .format((row.metrics.costMicros / 1000000) / row.metrics.clicks) : "0,00" }đ</td>
                          <td style={tdStyle}>{row.metrics?.costMicros && row.metrics?.conversions > 0  ? Intl.NumberFormat("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format((row.metrics.costMicros / 1000000) / row.metrics.conversions) : "0,00" }đ</td>
                          <td style={tdStyle}>{(row.metrics?.ctr*100).toFixed(2)}%</td>
                          <td style={tdStyle}>{row.metrics?.costMicros && row.metrics?.impressions > 0  ? Intl.NumberFormat("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(((row.metrics.costMicros / 1000000) / row.metrics.impressions)*1000) : "0,00" }đ</td>
                          <td style={tdStyle}>{row.segments?.date}</td>
                          <td style={tdStyle}>{row.segments?.device}</td>
                        </tr>
                        )
                    })}
                    </tbody>
                  </table>
                  </div>
                    
                  </div>
              </div>
            </div>
         </div> 
          <div style={{fontSize: 50, fontWeight: 'bold', textAlign: 'left', marginLeft: 30, marginTop: 10}}>Keyword</div>
            <div className="container-fluid">
              <div className="row">
                  <div className="col-md-12">
                     <div style={{marginRight: 10, width: 'fit-content'}}>
           <select className={styles.contentBookingBranchSelect} value={resourceKeyword} onChange={(e) => {
            setResourceKeyword(e.target.value)
            }}>
            {Object.entries(filteredKeywordData).map(([campaignId, rows]) => (
                <option key={campaignId} value={campaignId}>
                  {rows[0]?.campaign?.name}
                </option>
              ))}
      </select>
       <div style={paginationContainerStyle}>
          <button
            onClick={goPrev2}
            disabled={currentPage2 === 1}
            style={{
              ...paginationBtnStyle,
              ...(currentPage2 === 1 && paginationBtnDisabledStyle),
            }}
          >
            «
          </button>

          <span style={paginationTextStyle}>
            Page {currentPage2} / {totalPages2}
          </span>

          <button
            onClick={goNext2}
            disabled={currentPage2 === totalPages2}
            style={{
              ...paginationBtnStyle,
              ...(currentPage2 === totalPages2 &&
                paginationBtnDisabledStyle),
            }}
          >
            »
          </button>
        </div>
        </div>
                    <div>
                  <table border="1" style={{ ...tableStyle, marginTop: 20 }}>
                    <thead>
                      <tr>
                        <th style={{...thStyle, ...stickyHeader2}}>No.</th>
                        <th style={{...thStyle, ...stickyHeader2}} data-tip={t('marketing.googleAds.campaignID')} data-for="marketing">Campaign Name</th>
                        <th style={{...thStyle, ...stickyHeader2}}  data-tip={t('marketing.googleAds.campaignName')} data-for="marketing">
                          <div className="d-flex justify-content-between align-items-center">
                            <span>Keyword</span>
                            <div className="d-flex flex-column">
                              <button
                                className="btn-sort"
                                onClick={() => setSortType("!az")}
                                 style={{backgroundColor: 'transparent', border: 'none', height: 10}}
                              >
                                <i className="fa-solid fa-caret-up" style={{color: 'white', fontSize: 20}}></i>
                              </button>
                              <button
                                className="btn-sort"
                                onClick={() => setSortType("az")}
                                style={{backgroundColor: 'transparent', border: 'none', height: 10, marginBottom: 10}}
                              >
                                <i className="fa-solid fa-caret-down" style={{color: 'white', fontSize: 20}}></i>
                              </button>
                            </div>
                          </div>
                        </th>
                        <th style={{...thStyle, ...stickyHeader2, background: "linear-gradient(135deg, #4285F4 0%, #6EA8FF 100%)"}} data-tip={t('marketing.googleAds.conversion')} data-for="marketing">
                          <div className="d-flex justify-content-between align-items-center">
                            <span>Conversions</span>
                            <div className="d-flex flex-column">
                              <button
                                className="btn-sort"
                                onClick={() => setSortType("conversions-asc")}
                                 style={{backgroundColor: 'transparent', border: 'none', height: 10}}
                              >
                                <i className="fa-solid fa-caret-up" style={{color: 'white', fontSize: 20}}></i>
                              </button>
                              <button
                                className="btn-sort"
                                onClick={() => setSortType("conversions-desc")}
                                style={{backgroundColor: 'transparent', border: 'none', height: 10, marginBottom: 10}}
                              >
                                <i className="fa-solid fa-caret-down" style={{color: 'white', fontSize: 20}}></i>
                              </button>
                            </div>
                          </div>
                        </th>
                         <th style={{...thStyle, ...stickyHeader2, background: "linear-gradient(135deg, #DB4437 0%, #FF6B5E 100%)"}}  data-tip={t('marketing.googleAds.impression')} data-for="marketing">
                          <div className="d-flex justify-content-between align-items-center">
                            <span>Impressions</span>
                            <div className="d-flex flex-column">
                              <button
                                className="btn-sort"
                                onClick={() => setSortType("impressions-asc")}
                                 style={{backgroundColor: 'transparent', border: 'none', height: 10}}
                              >
                                <i className="fa-solid fa-caret-up" style={{color: 'white', fontSize: 20}}></i>
                              </button>
                              <button
                                className="btn-sort"
                                onClick={() => setSortType("impressions-desc")}
                                style={{backgroundColor: 'transparent', border: 'none', height: 10, marginBottom: 10}}

                              >
                                <i className="fa-solid fa-caret-down" style={{color: 'white', fontSize: 20}}></i>
                              </button>
                            </div>
                          </div>
                        </th>
                       <th style={{...thStyle, ...stickyHeader2, background: "linear-gradient(135deg, #F4B400 0%, #FFD95A 100%)"}}>
                          <div className="d-flex justify-content-between align-items-center"   data-tip={t('marketing.googleAds.click')} data-for="marketing">
                            <span>Clicks</span>
                            <div className="d-flex flex-column ml-1">
                              <button
                                className="btn-sort"
                                onClick={() => setSortType("clicks-asc")}
                                 style={{backgroundColor: 'transparent', border: 'none', height: 10}}
                              >
                                <i className="fa-solid fa-caret-up" style={{color: 'white', fontSize: 20}}></i>
                              </button>
                              <button
                                className="btn-sort"
                                onClick={() => setSortType("clicks-desc")}
                                style={{backgroundColor: 'transparent', border: 'none', height: 10, marginBottom: 10}}
                              >
                                <i className="fa-solid fa-caret-down" style={{color: 'white', fontSize: 20}}></i>
                              </button>
                            </div>
                          </div>
                        </th>
                         
                        <th style={{...thStyle, ...stickyHeader2, background: "linear-gradient(135deg, #0F9D58 0%, #34C97B 100%)"}}>
                           <div className="d-flex justify-content-between align-items-center"   data-tip={t('marketing.googleAds.cost')} data-for="marketing">
                            <span>Cost</span>
                            <div className="d-flex flex-column">
                              <button
                                className="btn-sort"
                                onClick={() => setSortType("cost-asc")}
                                 style={{backgroundColor: 'transparent', border: 'none', height: 10}}
                              >
                                <i className="fa-solid fa-caret-up" style={{color: 'white', fontSize: 20}}></i>
                              </button>
                              <button
                                className="btn-sort"
                                onClick={() => setSortType("cost-desc")}
                                style={{backgroundColor: 'transparent', border: 'none', height: 10, marginBottom: 10}}

                              >
                                <i className="fa-solid fa-caret-down" style={{color: 'white', fontSize: 20}}></i>
                              </button>
                            </div>
                          </div>
                        </th>
                        
                        <th style={{...thStyle, ...stickyHeader2, background: "linear-gradient(135deg, #AB47BC 0%, #D47BE3 100%)"}}>
                           <div className="d-flex justify-content-between align-items-center"   data-tip={t('marketing.googleAds.cpc')} data-for="marketing">
                            <span>CPC</span>
                            <div className="d-flex flex-column">
                              <button
                                className="btn-sort"
                                onClick={() => setSortType("cpc-asc")}
                                 style={{backgroundColor: 'transparent', border: 'none', height: 10}}
                              >
                                <i className="fa-solid fa-caret-up" style={{color: 'white', fontSize: 20}}></i>
                              </button>
                              <button
                                className="btn-sort"
                                onClick={() => setSortType("cpc-desc")}
                                style={{backgroundColor: 'transparent', border: 'none', height: 10, marginBottom: 10}}
                              >
                                <i className="fa-solid fa-caret-down" style={{color: 'white', fontSize: 20}}></i>
                              </button>
                            </div>
                          </div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentAdsData2
                      .filter(row => row.campaign.id === resourceKeyword)
                      .map((row, idx) => {
                        return (
                        <tr key={idx} style={{backgroundColor: idx % 2 == 0 ? "#fff" : "#E6E6E6"}} 
                        >
                          <td style={tdStyle}>{idx+1}</td>
                          <td style={tdStyle}>{row.campaign?.name}</td>
                          <td style={tdStyle}>{row.adGroupCriterion?.keyword?.text}</td>
                          <td style={tdStyle}>{Math.round(row.metrics?.conversions)}</td>
                          <td style={tdStyle}>{row.metrics?.clicks}</td>
                          <td style={tdStyle}>{row.metrics?.impressions}</td>
                          <td style={tdStyle}>{Intl.NumberFormat("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format((row.metrics?.costMicros)/1000000)}đ</td>
                          <td style={tdStyle}>{row.metrics?.averageCpc > 0 ?  Intl.NumberFormat("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format((row.metrics?.averageCpc)/1000000) : 0}đ</td>
                        </tr>
                        )
                    })}
                    </tbody>
                  </table>
                  </div>
                    
                  </div>
              </div>
            </div>
         </div> 
  );
}

const tableStyle = {
  width: "100%",
  borderCollapse: "collapse",
  borderRadius: 16,
  boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
  backgroundColor: "#fff",
  tableLayout: "auto",
  marginTop: 10
};
const thStyle = {
  padding: "14px 16px",
  textAlign: "center",
  background: "linear-gradient(135deg, #482979 0%, #6C4AB6 100%)",
  color: "#fff",
  fontSize: 20,
  fontWeight: 600,
  letterSpacing: "0.5px",
  boxShadow: "0 2px 6px rgba(0,0,0,0.12)",
};

const tdStyle = {
  padding: "12px 14px",
  textAlign: "center",
  border: "1px solid #e5e7eb",
  fontSize: 18,
  color: "#333",
  backgroundColor: "#fff",
  cursor: "pointer",
  whiteSpace: "nowrap", 
};
const stickyHeader = {
  fontSize: 16,
  position: 'sticky',top: 80,
  zIndex: 999
};
const stickyHeader2 = {
  fontSize: 16,
  position: 'sticky',top: 90,
  zIndex: 999
};
const paginationContainerStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 14,
  width: "fit-content",
  marginTop: 20,
  padding: "10px 16px",
  borderRadius: 16,
  background: "#fff",
  boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
};

const paginationBtnStyle = {
  height: 42,
  width: 42,
  border: "none",
  borderRadius: 12,
  background: "linear-gradient(135deg, #482979 0%, #6C4AB6 100%)",
  color: "#fff",
  fontSize: 20,
  fontWeight: 600,
  cursor: "pointer",
  transition: "all 0.25s ease",
  boxShadow: "0 4px 10px rgba(108, 74, 182, 0.25)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const paginationBtnDisabledStyle = {
  background: "#f3f4f6",
  color: "#9ca3af",
  cursor: "not-allowed",
  boxShadow: "none",
};

const paginationTextStyle = {
  fontSize: 16,
  fontWeight: 600,
  color: "#482979",
  whiteSpace: "nowrap",
};




